import React from 'react';
import PropTypes from 'prop-types';
import Icon from '../../components/Icon';

const LocationBlock = (props) => {
  const {
    selectedLocation,
    mapUrl,
    style = {}
  } = props;

  if (selectedLocation) {
    const phone = selectedLocation.phone;
    const phoneLinkHref = "callto:" + phone;

    return (
      <div className="appointment-block">
        {mapUrl && (<iframe className="google-iframe" style={{border: 0}} src={mapUrl} allowFullScreen width="100%"/>)}
        {selectedLocation.phone &&
          <div className="phone-block">
            <div className="telephone">
              <Icon iconName="phone" style={{...style.title}} />
              <a href={phoneLinkHref} style={{...style.title}}>
                {selectedLocation.phone}
              </a>
            </div>
          </div>
        }
      </div>
    );
  }

  return (<div className="block"><p>Invalid Location Address</p></div>);
};

LocationBlock.propTypes = {
  selectedLocation: PropTypes.object,
  mapUrl: PropTypes.string,
};

export default LocationBlock;
